import constants from "../constants";

const defaultState = {
  site_section: "destinations",
  page_type: "content page",
  content_group_1: "content",
  content_group_2: null,
  content_group_3: null,
  content_group_4: null,
  content_group_5: null,
  cd6_SiteSection: "destinations",
  cd7_Topic: "Things to Do",
  cd8_BookingType: null,
  cd9_TestExperience: "B:Destinations Template v1.0.0 Aug2016",
  cd10_ArticleName: null,
  cd21_AtlasDestination: null,
  cd22_ApplicationName: "dotcom-pois",
  cd24_LoginState: null,
};

export default function udo(state, action) {
  // Always include default values
  state = Object.assign({}, defaultState, state);

  switch (action.type) {
    case constants.INIT_POI: {
      return Object.assign({},
        state, {
          content_group_2: "pois",
        });
    }
    case constants.INIT_LIST: {
      return Object.assign({},
        state, {
          content_group_2: "lists",
        });
    }
    default:
      return { ...state };
  }
}


// WEBPACK FOOTER //
// ./assets/shared/reducers/udo.js